export const IconNames = {
  addUser: 'add-user',
  alertFilled: 'alert-filled',
  arrowDown: 'arrow-down',
  arrowLeft: 'arrow-left',
  arrowRight: 'arrow-right',
  arrowUp: 'arrow-up',
  arrowUp2: 'arrow-up-2',
  avatar: 'avatar',
  avatarFilled: 'avatar-filled',
  bell: 'bell',
  bold: 'bold',
  bulletPoint: 'bullet-point',
  calendar: 'calendar',
  calendarFilled: 'calendar-filled',
  candidate: 'candidate',
  centerAlign: 'center-align',
  checkmark: 'checkmark',
  circleCheckFilled: 'circle-check-filled',
  circleInfo: 'circle-info',
  circleInfoFilled: 'circle-info-filled',
  circleWaitingFilled: 'circle-waiting-filled',
  clock: 'clock',
  clockFilled: 'clock-filled',
  collapseAll: 'collapse-all',
  copy: 'copy',
  copyFormat: 'copy-format',
  copyHtml: 'copy-html',
  dollar: 'dollar',
  dollarFilled: 'dollar-filled',
  doubleChevronLeft: 'double-chevron-left',
  doubleChevronRight: 'double-chevron-right',
  download: 'download',
  envelope: 'envelope',
  envelopeFilled: 'envelope-filled',
  expandAll: 'expand-all',
  eye: 'eye',
  eyeHidden: 'eye-hidden',
  filter: 'filter',
  filterFilled: 'filter-filled',
  handle: 'handle',
  heart: 'heart',
  heartFilled: 'heart-filled',
  help: 'help',
  helpFilled: 'help-filled',
  intelligence: 'intelligence',
  intelligenceFilled: 'intelligence-filled',
  italic: 'italic',
  leftAlign: 'left-align',
  lightning: 'lightning',
  menu: 'menu',
  moveDown: 'move-down',
  moveUp: 'move-up',
  pencil: 'pencil',
  pencil2: 'pencil-2',
  pin: 'pin',
  pinFilled: 'pin-filled',
  placeholder: 'placeholder',
  popout: 'pop-out',
  plus: 'plus',
  minus: 'minus',
  open: 'open',
  reset: 'reset',
  rightAlign: 'right-align',
  settings: 'settings',
  search: 'search',
  share: 'share',
  sort: 'sort',
  sortAscending: 'sort-ascending',
  sortDescending: 'sort-descending',
  spacerVertical: 'spacer-vertical',
  spinner: 'spinner',
  star: 'star',
  starFilled: 'star-filled',
  strikeThrough: 'strike-through',
  tableau: 'tableau',
  trash: 'trash',
  underline: 'underline',
  verticalEllipsis: 'vertical-ellipsis',
  waypointFilled: 'waypoint-filled',
  xMark: 'x-mark',
} as const;

export type IconName = (typeof IconNames)[keyof typeof IconNames];
